module.exports = __webpack_public_path__ + "static/media/error_icon.e95f401b.svg";